import { type ExtractPropTypes, computed, type PropType } from 'vue';

import type { BreakpointType } from '../../typings/breakpointType';
import { BreakpointDepended } from '../breakpointDepended';

type FluidBreakpointType = { [key in BreakpointType]?: boolean };

export function withFluidProps(defaultValue?: boolean | FluidBreakpointType) {
  return {
    /**
     * Wyświetlaj element na pełnej dostępnej szerokości
     */
    fluid: {
      type: [Object, Boolean] as PropType<FluidBreakpointType | boolean>,
      default: defaultValue
    }
  };
}

export const useFluidProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withFluidProps>>) => {
  return computed(() => {
    if (typeof props.fluid === 'boolean' && props.fluid === true) {
      return `${prefix}--fluid`;
    } else if (typeof props.fluid !== 'boolean' && BreakpointDepended(props.fluid).value) {
      return `${prefix}--fluid`;
    }

    return;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesFluidArgs = {
  args: {
    fluid: false
  },

  argTypes: {
    fluid: {
      control: { type: 'boolean' }
    }
  }
};
